import { EncryptionService } from './../../../../Autofacets-Core/src/app/services/encryption.service';
import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DMSSyncFailedLogRequestModel } from '../business-entities/dmssyncfailedlog-request-model';
import { DmsSyncQueueLogRequestModel } from '../business-entities/dms-sync-queue-log-request-model';

@Injectable({
    providedIn: 'root'
})

export class DMSSyncFailedlogDataService {
    dataService: any;
    
    constructor(private dataProvider: DataService,private encryptionService:EncryptionService) {
    }

    GetDmsSyncFailedLog(dmsLogRequestModel: DMSSyncFailedLogRequestModel): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetDmsSyncFailedLog,dmsLogRequestModel).toPromise();
    }

    GetAfxSyncFailedLog(dmsLogRequestModel: any): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAfxSyncFailedLog,dmsLogRequestModel).toPromise();
    }

    GetModuleNamesList(): Promise<any>  {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetModuleNamesList).toPromise();
    }
    GetDmsSyncQueueLog(dmsSyncQueueLogRequestModel : DmsSyncQueueLogRequestModel): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetDmsSyncQueueLog,dmsSyncQueueLogRequestModel).toPromise();
    }
    DeleteQueue(rowId: any,deleteFrom:string): Promise<any>{
        return this.dataProvider.DeleteWithParams<GenericResponse<any>>(Urls.DeleteDMSSyncQueue,rowId,deleteFrom).toPromise();
      }
}
